export default {"src":"/_next/static/media/scallops.00dfde64.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};